<script>
/*global FaceView, */
/*eslint no-undef: "error"*/
import { defineComponent, watch, ref, nextTick } from "vue";
import { Layout } from "@/components";
import { GDialog } from "gitart-vue-dialog";
import { scriptsLoader } from "@/utils/scripts-loader";
import Step1 from '@/assets/svg/step1.svg';
import Step2 from '@/assets/svg/step2.svg';
import Step3 from '@/assets/svg/step3.svg';
import Hand from '@/assets/svg/hand.svg';
import NoGlasses from '@/assets/svg/no-glasses.svg';
import {Howl, Howler} from 'howler';
import { shadowBody } from "@/utils/build";

export default defineComponent({
  name: "App",
  components: {
    Layout,
    GDialog,
    Step1,
    Step2,
    Step3,
    Hand,
    NoGlasses
  },
  emits: ["measurementFinish"],
  setup(props, { emit }) {
    let step = ref(1);
    const camera = ref(null);
    const tryOn = ref(null);
    const inputImage = ref(null);
    const getSize = ref(null);
    let frontUrl = ref(null);
    let leftUrl = ref(null);
    let rightUrl = ref(null);
    let leftTempleWidth = ref(null);
    let rightTempleWidth = ref(null);
    let nextBtn = ref("次へ");
    let dialog1 = ref(true);
    let dialog2 = ref(false);
    let dialog3 = ref(false);
    let dialog4 = ref(false);
    let dialog5 = ref(false);
    let dialog6 = ref(false);
    let dialog7 = ref(false);
    let dialog8 = ref(false);
    let errDialog = ref(false);
    let isValidPhoto = ref(false);
    let loading = ref(false);
    const isScriptsLoaded = ref(false);
    let pd = ref(0);
    let faceWidth = ref(0);
    let templeLens = ref(0);
    let showIndicator = ref(true);
    let tempImg = ref(null);
    const sound = new Howl({ src: ['https://production-glasson.s3.ap-northeast-1.amazonaws.com/hello-o/camera-shutter.mp3']});
    // *: Define use

    // *: Define computed

    // *: Define watch & method

    function doVariant() {
      const data = {
        pdSize: pd.value,
        faceWidth: faceWidth.value,
        leftTempleWidth: leftTempleWidth.value,
        rightTempleWidth: rightTempleWidth.value,
        userFrontPhoto: frontUrl.value,
        userLeftPhoto: leftUrl.value,
        userRightPhoto: rightUrl.value
      };
      emit("measurementFinish", data);
    }

    const onNextClick = (value) => {
      if (loading.value) return;
      if (value === 5 && !isValidPhoto.value) {
        loading.value = true;
        uploadImage(tempImg.value, 'front');
        return
      }
      if (value === 6 && !isValidPhoto.value) {
        loading.value = true;
        uploadImage(tempImg.value, 'right');
        return
      }
      if (value === 7 && !isValidPhoto.value) {
        loading.value = true;
        uploadImage(tempImg.value, 'left');
        return
      }
      if (value === 1) {
        step.value = 2;
        dialog2.value = true;
        dialog1.value = false;
        nextBtn.value = "了承して次へ";
      } else if (value === 2) {
        step.value = 3;
        dialog3.value = true;
        dialog2.value = false;
        nextBtn.value = "同意して次へ";
      } else if (value === 3) {
        step.value = 4;
        dialog4.value = true;
        dialog3.value = false;
        nextBtn.value = "同意して測定をはじめる";
      } else if (value === 4) {
        step.value = 5;
        dialog5.value = true;
        dialog4.value = false;
        nextBtn.value = "測定する";
      } else if (value === 5) {
        step.value = 6;
        dialog6.value = true;
        dialog5.value = false;
        isValidPhoto.value = false;
        nextBtn.value = "測定する";
      } else if (value === 6) {
        step.value = 7;
        dialog7.value = true;
        dialog6.value = false;
        isValidPhoto.value = false;
        nextBtn.value = "測定する";
      } else if (value === 7) {
        step.value = 8;
        dialog8.value = true;
        dialog7.value = false;
        isValidPhoto.value = false;
        nextBtn.value = "オーダーフローに戻る";
      } else {
        doVariant();
        // step.value = 1;
        // dialog1.value = true;
        // dialog8.value = false;
        // nextBtn.value = "次へ";
      }
    };

    function startCamera() {
      if (!tryOn.value || !camera.value) return;
      loading.value = true;
      // console.log(getSize.value.clientWidth)
      // tryOn.value.width = camera.value.clientWidth;
      // tryOn.value.height = camera.value.clientHeight;
      tryOn.value.height = tryOn.value.width;
      let tryOnView = new FaceView(
        "tryon_canvas",
        camera.value.getRootNode()
        // shadowBody()?.getRootNode()
      );
      if (dialog5.value) {
        tryOnView
          .start(
            () => {
              // front event
              sound.play()
              tryOn.value.toBlob((blob) => {
                // uploadImage(blob, "front");
                tempImg.value = blob;
                loading.value = false;
              });
              requestAnimationFrame(function () {
                tryOnView.stop();
                tryOnView = null;
              });
              loading.value = false;
            },
            () => {} // side event
          )
          .then(
            function () {
              showIndicator.value = false
            },
            function () {}
          );
      } else if (dialog6.value || dialog7.value) {
        tryOnView
          .start(
            () => {},
            () => {
              sound.play()
              tryOn.value.toBlob((blob) => {
                // if (blob && dialog6.value) {
                //   uploadImage(blob, "right");
                // } else if (blob && dialog7.value) {
                //   uploadImage(blob, "left");
                // }
                tempImg.value = blob;
                loading.value = false;
              });
              requestAnimationFrame(function () {
                tryOnView.stop();
                tryOnView = null;
              });
            }
          )
          .then(
            function () {
              showIndicator.value = false
            },
            function (err) {}
          );
      }
    }

    function getFront() {
      var formData = new FormData();
      formData.append("url_image", frontUrl.value);
      fetch(`https://helloo-measure.sk-global.io/api/front_api`, {
        method: "POST",
        body: formData
      }).then(async (res) => {
        const data = await res.json();
        if (data.result.pupil_distance) {
          pd.value = Math.round(data.result.pupil_distance);
          faceWidth.value = Math.round(data.result.head_distance);
          loading.value = false;
          isValidPhoto.value = true;
          onNextClick(5);
        } else {
          // startCamera();
          errDialog.value = true;
        }
        showIndicator.value = false;
      });
    }
    function getSide(side) {
      var formData = new FormData();
      if (side === "right") {
        formData.append("url_image", rightUrl.value);
      } else {
        formData.append("url_image", leftUrl.value);
      }
      fetch(`https://helloo-measure.sk-global.io/api/side_api`, {
        method: "POST",
        body: formData
      }).then(async (res) => {
        const data = await res.json();
        if (data.result.ear_distance && side === "right") {
          templeLens.value = Math.round(data.result.ear_distance);
          rightTempleWidth.value = Math.round(data.result.ear_distance);
          isValidPhoto.value = true;
          loading.value = false;
          onNextClick(6);
        } else if (data.result.ear_distance && side === "left") {
          templeLens.value = Math.round(data.result.ear_distance);
          leftTempleWidth.value = Math.round(data.result.ear_distance);
          isValidPhoto.value = true;
          loading.value = false;
          onNextClick(7);
        } else {
          // startCamera();
          errDialog.value = true;
        }
        loading.value = false;
        showIndicator.value = false;
      });
    }

    function uploadImage(blob, type) {
      showIndicator.value = true;
      var formData = new FormData();
      formData.append("file", blob, `${type}.png`);
      fetch(
        `https://glasson.sk-global.biz/api/v2/Attachments/production-glasson/upload`,
        {
          method: "POST",
          body: formData
        }
      ).then(async (res) => {
        const data = await res.json();
        const path = data.result.files.file[0].providerResponse.location;
        if (type === "front") {
          frontUrl.value = path;
          getFront();
        } else if (type === "right") {
          rightUrl.value = path;
          getSide("right");
        } else if (type === "left") {
          leftUrl.value = path;
          getSide("left");
        }
      });
    }

    watch(dialog5, () => {
      if (dialog5.value) {
        nextTick(() => startCamera());
      }
      // startCamera()
    });
    watch(dialog6, () => {
      if (dialog6.value) {
        nextTick(() => startCamera());
      }
      // startCamera()
    });
    watch(dialog7, () => {
      if (dialog7.value) {
        nextTick(() => startCamera());
      }
      // startCamera()
    });
    watch(errDialog, () => {
      if (!errDialog.value) {
        nextTick(() => startCamera());
      }
    });

    const scripts = [
      "https://cdn.jsdelivr.net/npm/@tensorflow/tfjs",
      "https://cdn.jsdelivr.net/npm/@tensorflow-models/blazeface",
      "https://production-glasson.s3.ap-northeast-1.amazonaws.com/hello-o/face_view.min.js"
    ];
    scriptsLoader
      .reset()
      .addScript(scripts)
      .afterLoad()
      .onComplete(() => {
        // console.info("ALL SCRIPTS LOADED");
        // isScriptsLoaded.value = true;
        isScriptsLoaded.value = true;
        // nextTick(() => startCamera());
      })
      .load();

    return {
      isScriptsLoaded,
      step,
      dialog1,
      dialog2,
      dialog3,
      dialog4,
      dialog5,
      dialog6,
      dialog7,
      dialog8,
      startCamera,
      onNextClick,
      pd,
      faceWidth,
      templeLens,
      camera,
      tryOn,
      inputImage,
      loading,
      getSize,
      nextBtn,
      showIndicator,
      errDialog,
      // rightUrl,
      // leftUrl,
      // frontUrl,
      // leftTempleWidth,
      rightTempleWidth,
    };
  }
});
</script>

<template>
  <Layout>
    <template #footer>
      <section
        class="go-functions q-mb-md"
        style="display: flex; justify-content: center"
      >
        <q-btn
          ref="getSize"
          style="width: 80%; border-radius: 20px; height: 2.5rem"
          color="black"
          @click="onNextClick(step)"
          :disable="((loading && dialog5) || (loading && dialog6) || (loading && dialog7))"
        >
          {{ nextBtn }}
          <i class="arrow-right"></i>
        </q-btn>
      </section>
    </template>
    <GDialog v-model="dialog1" local fullscreen>
      <q-card class="fit">
        <q-card-section class="helloo-title">
          <h2 class="text-h5 q-mt-none q-mb-sm">HELLOO MY NAME IS...</h2>
          <p class="text-body2 q-my-none">サイズ測定ツール</p>
        </q-card-section>
        <div class="helloo-body column justify-center full-width">
          <div class="full-width">
            <q-card-section>
              <div class="text-center text-body2">
                あなたのサイズにフィットするアイウェアを作るた<br />
                め、頭や顔のサイズを測定します。<br />
                お送りした測定メガネをご用意ください。
              </div>
            </q-card-section>
            <q-card class="step-card">
              <q-card-section horizontal>
                <div class="col-4 step-image">
                  <!-- <img style="max-width: 60%" src="@/assets/svg/step1.svg" /> -->
                  <Step1 style="max-width: 60%"/>
                </div>
                <q-card-section class="col-8">
                  <div>STEP.1</div>
                  <q-separator />
                  <div class="md-text">PD・顔幅の測定</div>
                  <div style="font-size: 0.75rem">
                    PD（瞳孔間距離）と顔幅を測定し
                  </div>
                </q-card-section>
              </q-card-section>
            </q-card>
            <q-card class="step-card">
              <q-card-section horizontal>
                <div class="col-4 step-image">
                  <Step2 style="max-width: 60%"/>
                  <!-- <q-img style="max-width: 60%" src="./assets/svg/step2.svg" /> -->
                </div>
                <q-card-section class="col-8">
                  <div>STEP.2</div>
                  <q-separator />
                  <div class="md-text">テンプル長の測定（右側）</div>
                  <div style="font-size: 0.75rem">
                    耳から目までの距離を測定します。
                  </div>
                </q-card-section>
              </q-card-section>
            </q-card>
            <q-card class="step-card">
              <q-card-section horizontal>
                <div class="col-4 step-image">
                  <Step3 style="max-width: 60%"/>
                  <!-- <q-img style="max-width: 60%" src="./assets/svg/step3.svg" /> -->
                </div>
                <q-card-section class="col-8">
                  <div>STEP.3</div>
                  <q-separator />
                  <div class="md-text">テンプル長の測定（左側）</div>
                  <div style="font-size: 0.75rem">
                    耳から目までの距離を測定します。
                  </div>
                </q-card-section>
              </q-card-section>
            </q-card>
          </div>
        </div>
      </q-card>
    </GDialog>

    <GDialog transition="custom-from-right-transition" v-model="dialog2" local fullscreen>
      <q-card class="fit">
        <q-card-section class="helloo-title">
          <h2 class="text-h5">モデルの適合について</h2>
        </q-card-section>
        <div class="helloo-body column justify-center full-width">
          <div class="full-width">
            <q-card-section class="flex-center" style="padding: 5px 0px">
              <NoGlasses style="max-width: 100%"/>
              <!-- <q-img style="max-width: 80%" src="./assets/svg/no-glasses.svg" /> -->
            </q-card-section>
            <q-card-section>
              <div class="text-justify text-subtitle2 text-weight-regular">
                測定の結果やレンズの度数によって、お選び頂いたモデルやカスタマイズが適合しない場合がございます。<br />
                適合しない可能性がある場合、測定後にスタッフより個別にご案内を差し上げますので、何卒ご了承ください。
              </div>
            </q-card-section>
          </div>
        </div>
      </q-card>
    </GDialog>

    <GDialog transition="custom-from-right-transition" v-model="dialog3" local fullscreen>
      <q-card class="fit">
        <q-card-section class="helloo-title">
          <h2 class="text-h5">測定のまえに</h2>
        </q-card-section>
        <div class="helloo-body column justify-center full-width">
          <div class="full-width">
            <q-card class="allow-card">
              <q-card-section> 写真へのアクセスを求めています。 </q-card-section>
              <q-separator />
              <q-card-section horizontal style="color: #007aff">
                <q-card-section class="col-6"> 許可しない </q-card-section>
                <q-separator vertical />
                <q-card-section class="col-6"> OK </q-card-section>
                <!-- <q-img
                  style="
                    max-width: 40px;
                    position: absolute;
                    right: 30px;
                    bottom: -30px;
                  "
                  src="./assets/svg/hand.svg"
                /> -->
                <Hand 
                  style="
                    max-width: 40px;
                    position: absolute;
                    right: 60px;
                    bottom: -40px;
                  "
                />
              </q-card-section>
            </q-card>
            <q-card-section>
              <div class="text-justify text-subtitle2 text-weight-regular">
                お使いのスマートフォンのカメラを使用して、頭や顔<br />
                のサイズを測定します。測定が開始されると、カメラ<br />
                へのアクセス権限を求める案内が表示されますので、<br />
              「許可」や「OK」をご選択ください。
              </div>
            </q-card-section>
          </div>
        </div>
      </q-card>
    </GDialog>

    <GDialog transition="custom-from-right-transition" v-model="dialog4" local fullscreen>
      <q-card class="fit">
        <q-card-section class="helloo-title">
          <h2 class="text-h5">撮影画像の取り扱いについて</h2>
        </q-card-section>
        <div class="helloo-body column justify-center full-width">
          <div class="full-width">
            <q-card-section class="flex-center" style="padding: 5px 0px">
              <q-img 
                style="max-width: 80%" 
                loading="eager"
                fetchpriority="high"
                no-spinner
                src="https://glasson-helloo.s3.ap-northeast-1.amazonaws.com/glasson-measurement-assets/upload.f4473267.png" 
              />
            </q-card-section>
            <q-card-section>
              <div class="text-justify text-subtitle2 text-weight-regular">
                サイズ測定の行程において、お送りした測定用紙メガネをかけた状態で横方向からの撮影を行います。<br/>
                撮影した写真データについては、フィッティングの調整作業の参考に使用する場合がございますので、ご注文頂いた商品の保証期間中は
                株式会社 エスケイワイ が保管し、保証期間終了とともに消去いたします。
              </div>
            </q-card-section>
          </div>
        </div>
      </q-card>
    </GDialog>

    <GDialog transition="custom-from-right-transition" v-model="dialog5" local fullscreen>
      <q-card class="fit">
        <q-card-section class="helloo-title">
          <h2 class="text-h5 q-mt-none q-mb-sm">STEP.1</h2>
          <p class="text-body2 q-my-none">PD・顔幅の測定</p>
        </q-card-section>
        <div class="helloo-body column justify-center full-width">
          <div class="full-width">
            <q-card-section class="q-pa-none">
              <div class="text-center text-body1 q-mb-sm">
                測定メガネを着用して、<br/>
                正面を向いてください。
              </div>
              <div
                v-if="isScriptsLoaded && dialog5"
                ref="camera"
                style="width: 100%; height: 100%; margin: 0px 0px"
              >
                <q-inner-loading
                  :showing="showIndicator"
                  class="absolute z-top"
                >
                  <q-spinner-ios size="50px" color="black" />
                </q-inner-loading>
                <!-- <img class="indicator" v-show="showIndicator" src="https://d3lgac2qoojxa5.cloudfront.net/libs/icon-mono.png" alt="" /> -->
                <canvas
                  id="tryon_canvas"
                  ref="tryOn"
                  style="width: 100%; height: 100%;"
                />
                <video id="video" playsinline style="display: none" />
              </div>
              <div class="text-center text-body1 q-mt-xs">シャッター音が鳴れば、次に進みます。</div>
            </q-card-section>
          </div>
        </div>
      </q-card>
    </GDialog>

    <GDialog transition="custom-from-right-transition" v-model="dialog6" local fullscreen>
      <q-card class="fit">
        <q-card-section class="helloo-title">
          <h2 class="text-h5 q-mt-none q-mb-sm">STEP.2</h2>
          <p class="text-body2 q-my-none">テンプル長の測定（右側）</p>
        </q-card-section>
        <div class="helloo-body column justify-center full-width">
          <div class="full-width">
            <q-card-section class="q-pa-none">
              <div class="text-center text-body1 q-mb-md">
                測定メガネを着用して、<br/>
                <span class="text-h5">左</span>を向いてください。
              </div>
              <div
                v-if="isScriptsLoaded && dialog6"
                ref="camera"
                style="width: 100%; height: 100%;"
              >
                 <q-inner-loading
                  :showing="showIndicator"
                  class="absolute z-top"
                >
                  <q-spinner-ios size="50px" color="black" />
                </q-inner-loading>
                <!-- <img class="indicator" v-show="showIndicator" src="https://d3lgac2qoojxa5.cloudfront.net/libs/icon-mono.png" alt="" /> -->
                <canvas
                  v-show="!showIndicator"
                  id="tryon_canvas"
                  ref="tryOn"
                  style="width: 100%; height: 100%"
                />
                <video id="video" playsinline style="display: none" />
              </div>
              <div class="text-center text-body1 q-mt-sm">シャッター音が鳴れば、次に進みます。</div>
            </q-card-section>
          </div>
        </div>
      </q-card>
    </GDialog>

    <GDialog transition="custom-from-right-transition" v-model="dialog7" local fullscreen>
      <q-card style="height: 100%">
        <q-card-section class="helloo-title">
          <h2 class="text-h5 q-mt-none q-mb-sm">STEP.3</h2>
          <p class="text-body2 q-my-none">テンプル長の測定（右側）</p>
        </q-card-section>
        <div class="helloo-body column justify-center full-width">
          <div class="full-width">
            <q-card-section class="q-pa-none">
              <div class="text-center text-body1 q-mb-md">
                測定メガネを着用して、<br/>
                <span class="text-h5">右</span>を向いてください
              </div>
              <div
                v-if="isScriptsLoaded && dialog7"
                ref="camera"
                style="width: 100%; height: 100%; margin: 20px 0"
              >
                 <q-inner-loading
                  :showing="showIndicator"
                  class="absolute z-top"
                >
                  <q-spinner-ios size="50px" color="black" />
                </q-inner-loading>
                <!-- <img class="indicator" v-show="showIndicator" src="https://d3lgac2qoojxa5.cloudfront.net/libs/icon-mono.png" alt="" /> -->
                <canvas
                  id="tryon_canvas"
                  ref="tryOn"
                  style="width: 100%; height: 100%"
                />
                <video id="video" playsinline style="display: none" />
              </div>
              <div class="text-center text-body1 q-mt-sm">シャッター音が鳴れば、測定完了です。</div>
            </q-card-section>
          </div>
        </div>
      </q-card>
    </GDialog>

    <GDialog transition="custom-from-right-transition" v-model="dialog8" local fullscreen>
      <q-card class="fit">
        <q-card-section class="helloo-title">
          <h2 class="text-h5">測定結果</h2>
        </q-card-section>
        <div class="helloo-body column justify-center full-width">
          <div class="full-width">
            <q-card-section>
              <q-list class="text-step-7">
                <q-item>
                  <q-item-section>
                    <q-item-label>PD</q-item-label>
                  </q-item-section>

                  <q-item-section side>
                    <q-item-label style="color: black"> {{ pd }}mm </q-item-label>
                  </q-item-section>
                </q-item>

                <q-separator spaced inset size="2px" />

                <q-item>
                  <q-item-section>
                    <q-item-label>顔幅</q-item-label>
                  </q-item-section>

                  <q-item-section side>
                    <q-item-label style="color: black">
                      {{ faceWidth }}mm
                    </q-item-label>
                  </q-item-section>
                </q-item>

                <q-separator spaced inset size="2px" />

                <q-item>
                  <q-item-section>
                    <q-item-label>左テンプル長</q-item-label>
                  </q-item-section>

                  <q-item-section side>
                    <q-item-label style="color: black">
                      {{ templeLens }}mm
                    </q-item-label>
                  </q-item-section>
                </q-item>

                <q-separator spaced inset size="2px" />

                <q-item>
                  <q-item-section>
                    <q-item-label>右テンプル長</q-item-label>
                  </q-item-section>

                  <q-item-section side>
                    <q-item-label style="color: black">
                      {{ rightTempleWidth }}mm
                    </q-item-label>
                  </q-item-section>
                </q-item>
              </q-list>
            </q-card-section>
            <q-card-section>
              <div class="text-center text-body1">
                測定にご協力いただき、<br />
                ありがとうございました。
              </div>
            </q-card-section>
          </div>
        </div>
      </q-card>
    </GDialog>

    <GDialog transition="custom-from-right-transition" v-model="errDialog" local>
      <q-card style="height: 100%">
        <q-card-section class="q-pb-none">
          <pre class="text-center small-text" style="white-space: pre-line">
            測定できませんでした。
            測定メガネを着用して、やり直してください。
          </pre>
        </q-card-section>
        <q-card-action style="display: flex; justify-content: center; align-items: center;">
          <q-btn
            @click="errDialog=false"
            color="black"
            label="OK"
            text-color="white"
            style="margin-bottom: 10px!important"
            unelevated
            rounded
          />
        </q-card-action>
      </q-card>
    </GDialog>
  </Layout>
</template>

<style lang="scss">
@import "assets/scss/app.scss";
</style>
